export default "__VITE_ASSET__WZ7ULQ37__"